import Cookies from "universal-cookie";

const cookies = new Cookies();

export const getCookieData = cookieName => {
  const cName = cookieName;
  let cookieData = cookies.get(cName);

  if (cookieData) {
    return cookieData;
  } else {
    return null;
  }
};

export const setCookieData = (cookieName, data, options) => {
  const cName = cookieName;

  cookies.set(cName, data, options);
};

// identity_assumed_by: JWT claim (not in /api/user) = the assuming support user's id.
const decodeBase64Url = (segment) => {
  // Normalize base64url (-/_, unpadded) before atob, which is strict base64.
  const b64 = segment.replace(/-/g, "+").replace(/_/g, "/");
  const padded = b64 + "=".repeat((4 - (b64.length % 4)) % 4);
  return atob(padded);
};

const readTokenClaims = () => {
  try {
    const token = getCookieData(process.env.REACT_APP_COOKIE_NAME);
    if (!token) return null;
    return JSON.parse(decodeBase64Url(token.split(".")[1]));
  } catch {
    return null;
  }
};

// True when a support/admin engineer is logged in via assumed identity.
export const isSupportSession = () => !!readTokenClaims()?.identity_assumed_by;

// The user id of the support/admin engineer who assumed the identity, or null.
export const getAssumedByUserId = () => readTokenClaims()?.identity_assumed_by || null;
